import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-level-green px-5 py-20 sm:px-8" data-id="element-102" data-mp="1o2vfqkp72f4g">
      <Reveal className="mx-auto w-full max-w-2xl" data-id="element-103" data-mp="223y6har4wdlp">
        <div className="rounded-3xl bg-white px-7 py-12 text-center shadow-[0_24px_60px_-36px_rgba(22,50,79,0.45)] sm:px-12" data-id="element-104" data-mp="222mzz36b0rqw">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-level-green/12" data-id="element-105" data-mp="19eqxfhu205m7">
            <ShieldCheckIcon className="h-7 w-7 text-level-green" aria-hidden="true" data-id="element-106" data-mp="14fxu2i8hduzr" />
          </span>

          <h2 className="mt-6 text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-107" data-mp="1j52bvybd5x7c">
            Få tillbaka dina pengar eller behåll det.
          </h2>

          <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-muted" data-id="element-108" data-mp="1ec0wlp78vvn8">
            Prova Innebandy Ready riskfritt i 30 dagar. Om det inte sparar dig timmar av
            planering, mejla oss för full återbetalning — och du får behålla alla bonusar.
          </p>
        </div>
      </Reveal>
    </section>;
}